export const CONDITIONS = {
  CONDITIONS_SET_SELECTED: "CONDITIONS_SET_SELECTED",
  CONDITIONS_CLEAR_SELECTED: "CONDITIONS_CLEAR_SELECTED",
};
